// Query surface of GET stripe/payouts (flag REACT_APP_STRIPE_PAYOUTS_ENABLED).
// from/to are calendar dates (yyyy-MM-dd, the API filters on ArrivalDate);
// q matches payout id, order number, payment intent or charge id.

export interface StripePayoutsQuery {
  from?: string;
  to?: string;
  q?: string;
  pageIndex: number;
  pageSize: number;
}

// Builds "?pageIndex=1&pageSize=25[&from=…][&to=…][&q=…]". Empty/blank
// filters are omitted; the free-text q is encoded exactly once here (callers
// pass the raw term).
export function toStripePayoutsQueryParam(query: StripePayoutsQuery): string {
  const segments: string[] = [
    `pageIndex=${query.pageIndex}`,
    `pageSize=${query.pageSize}`,
  ];
  if (query.from && query.from.trim() !== "") {
    segments.push(`from=${encodeURIComponent(query.from.trim())}`);
  }
  if (query.to && query.to.trim() !== "") {
    segments.push(`to=${encodeURIComponent(query.to.trim())}`);
  }
  if (query.q && query.q.trim() !== "") {
    segments.push(`q=${encodeURIComponent(query.q.trim())}`);
  }
  return `?${segments.join("&")}`;
}
